import { render, staticRenderFns } from "./UtilityBarItem.vue?vue&type=template&id=e45a2698&"
import script from "./UtilityBarItem.vue?vue&type=script&lang=ts&"
export * from "./UtilityBarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports